import { getHomeConfig, addHomeConfig, delHomeConfig, getCustomerConfig, addCustomeConfig, delCustomeConfig } from '@/api/home/homeConfig'
import { message } from 'ant-design-vue'
import { useUserStore } from '@/store'

export class HomeConfigController {
  static async list () {
    return await getHomeConfig({ category: useUserStore().userInfo.agent.category })
  }

  static async addHomeConfig (data: any) {
    const { code, msg } = await addHomeConfig({
      ...data,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async delHomeConfig (id: string) {
    const { code, msg } = await delHomeConfig(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }

  static async customerList () {
    return await getCustomerConfig({ category: useUserStore().userInfo.agent.category })
  }

  static async addCustomeConfig (data: any) {
    const { code, msg } = await addCustomeConfig({
      ...data,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async delCustomeConfig (id: string) {
    const { code, msg } = await delCustomeConfig(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }
}
